import type { FC, ReactNode } from 'react';
import { useCallback } from 'react';

import { HideNavigation } from '@luna/router';
import { shouldUseEmbeddedLayout, useNavigationContext } from '@shared/core-ui-layout';

import style from './FocusPageWrapper.module.scss';

interface Props {
    children: ReactNode;
}

export const FocusPageWrapper: FC<Props> = ({ children }) => {
    const { setValue } = useNavigationContext();

    const wrappedFocusPage = (
        <main className={style.container} data-cy="nodal-container">
            {children}
        </main>
    );

    const handleSetNavigation = useCallback((val: boolean) => {
        setValue({ visible: val });
    }, []);

    if (shouldUseEmbeddedLayout()) {
        return wrappedFocusPage;
    }

    return (
        <HideNavigation setIsNavigationVisible={handleSetNavigation}>
            {wrappedFocusPage}
        </HideNavigation>
    );
};
